import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Dialog, DialogTitle, DialogContent, IconButton, Container } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import apiInstance from '../../../../services/ServiceApi';
import ConstructorFormulario from '../../../../components/LineaNegocio/formulario/ConstructorFormulario';
import LineaNegocioAdd from './LineaNegocioAdd';
import Plantilla from '../../../../components/LineaNegocio/plantilla/Plantilla';
import LinkDashboard from '../../../../components/LineaNegocio/LinkDashboard';

const TablaLineaNegocio = () => {
    const [data, setData] = useState([]);
    const [lineaNegocio, setLineaNegocio] = useState(null);
    const [open, setOpen] = useState(false);
    const [openFormulario, setOpenFormulario] = useState(false);
    const [openPlantilla, setOpenPlantilla] = useState(false);
    const [openAddDashboard, setOpenAddDashboard] = useState(false);
    
    const fetchLineaNegocio = async () => {
        try {
            const response = await apiInstance.get('/lineasnegocio/');
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data', error);
        }
    };

    const handleEdit = (row) => {
        setOpenFormulario(true)
        setLineaNegocio(row);
    };
    const handleEditPlantilla = (row) => {
        setOpenPlantilla(true)
        setLineaNegocio(row);
    };
    const handleAddDashboard = (row) =>{
        setOpenAddDashboard(true)
        setLineaNegocio(row);
    }
    
    const toggleModal = () => {
        setOpen(prevOpen => !prevOpen);
    };
    

    useEffect(() => {
        fetchLineaNegocio();
    }, []);

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        { field: 'linea_negocio', headerName: 'Linea de negocio', width: 150 },
        { field: 'empresa', headerName: 'Empresa', width: 150 },
        { field: 'empresa_nombre', headerName: 'Nombre de la empresa', width: 200 },
        {
            field: 'editar',
            headerName: 'Editar Formulario',
            width: 200,
            renderCell: (params) => (
                <IconButton 
                    color="primary" 
                    onClick={() => handleEdit(params.row)}
                    title="Editar Formulario"
                >
                    <EditIcon />
                </IconButton>
            )
        },
        {
            field: 'editar_plantilla',
            headerName: 'Editar Plantilla',
            width: 200,
            renderCell: (params) => (
                <IconButton 
                    color="primary" 
                    onClick={() => handleEditPlantilla(params.row)}
                    title="Editar Plantilla"
                >
                    <EditIcon />
                </IconButton>
            )
        },
        {
            field: 'link_dashboard',
            headerName: 'Agregar Link Dashboard',
            width: 200,
            renderCell: (params) => (
                <IconButton 
                    color="primary" 
                    onClick={() => handleAddDashboard(params.row)}
                    title="Agregar Link Dashboard"
                >
                    <EditIcon />
                </IconButton>
            )
        }
    ];
    return (
        <Container>
            <Button variant="contained" 
                    color="secondary"
                    startIcon={<AddIcon />}
                    onClick={toggleModal}>
                    Agregar Línea de Negocio
            </Button>

            <Dialog open={open} onClose={toggleModal}>
                <DialogTitle>Agregar Línea de Negocio</DialogTitle>
                <DialogContent>
                    <LineaNegocioAdd />
                </DialogContent>
            </Dialog>

            <DataGrid rows={data} columns={columns} pageSize={5} checkboxSelection={false} />

            <Dialog open={openFormulario} onClose={() => setOpenFormulario(false)} maxWidth="lg">
                <DialogTitle>Agregar Línea de Negocio</DialogTitle>
                <DialogContent>
                    {lineaNegocio && <ConstructorFormulario formulario={lineaNegocio.formulario} linea_negocio_id={lineaNegocio.id} />}
                </DialogContent>
            </Dialog>

            <Dialog open={openPlantilla} onClose={() => setOpenPlantilla(false)} maxWidth="lg">
                <DialogTitle>Modificar Plantilla</DialogTitle>
                <DialogContent>
                    {lineaNegocio && <Plantilla linea_negocio = {lineaNegocio} />}
                </DialogContent>
            </Dialog>
            <Dialog open={openAddDashboard} onClose={() => setOpenAddDashboard(false)} maxWidth="lg">
                <DialogTitle>Añadir Link de Dashboard</DialogTitle>
                <DialogContent>
                    {lineaNegocio && <LinkDashboard linea_negocio = {lineaNegocio}  onClose={() => setOpenAddDashboard(false)} />}
                </DialogContent>
            </Dialog>

        </Container>
    );
};

export default TablaLineaNegocio;